import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import acs from '@mos-utils/acs';
import { useAuthorizationStatus } from '@mos-utils/acs-react';

import HomePage from './containers/HomePage';
import SuccessPage from './containers/SuccessPage';
import CancelPage from './containers/CancelPage';
import FormPageLayout from './layouts/FormPageLayout';
import history, { basename } from './AppHistory';

const AppRoutes = ({ setHomeRoute }) => {
  const authorizationStatus = useAuthorizationStatus();

  useEffect(() => {
    const backUrl =
      authorizationStatus === 'authorized'
        ? `${window.location.origin}${basename}`
        : window.location.href;
    acs.configure({
      backUrl
    });
  }, [authorizationStatus]);

  const renderComponent = (routeProps, isHomePage, Component) => {
    setHomeRoute(isHomePage);

    return <Component {...routeProps} />;
  };

  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route
          exact
          path="/"
          render={routeProps => renderComponent(routeProps, true, HomePage)}
        />
        <Route
          path="/new/"
          render={routeProps =>
            renderComponent(routeProps, false, FormPageLayout)
          }
        />
        <Route
          path="/success-submit/"
          render={routeProps => renderComponent(routeProps, false, SuccessPage)}
        />
        <Route
          path="/success-denial/"
          render={routeProps => renderComponent(routeProps, false, SuccessPage)}
        />
        <Route
          path="/cancel/:serviceNumber"
          render={routeProps => renderComponent(routeProps, false, CancelPage)}
        />
        <Route
          path="/cancel/success-cancel/:serviceNumber"
          render={routeProps => renderComponent(routeProps, false, CancelPage)}
        />
        <Redirect to="/" />
      </Switch>
    </ConnectedRouter>
  );
};

AppRoutes.propTypes = {
  setHomeRoute: PropTypes.func.isRequired
};

export default AppRoutes;
